import styled from 'styled-components'

export const ModalFooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const ModalBodyWrapper = styled.div`
  font-size: 14.5px;
  font-weight: 400;
  padding: 0px 0px 20px 0px;
`

export const ModalFooterButton = styled.div`
  margin: 0px 0px 0px 10px;
`
export const ColWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
export const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
export const ResultTitle = styled.div``
export const ResultText = styled.div``
export const ResultCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  gap: 12px;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.backgroundLite};
`
export const ResultContainer = styled.div``
export const ResultActionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
export const ResultActionContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
`

export const CopyNotification = styled.div`
  position: absolute;
  top: 100%;
  margin-top: 10px;

  font-size: 15px;
  font-weight: 400;
  padding: 10px 20px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.background};

  transition: 0.1s;
  opacity: ${({ display }) => (display ? 1 : 0)};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15);
`
